<template>
  <div>
    <transition name="fade" :duration="{ enter: 300, leave: 300 }">
      <v-btn class="mt-12 ma-3" style="z-index: 0" v-show="!isVisible" color="primary" fab large dark absolute top left @click="toggle(true)">
        <v-icon>mdi-file</v-icon>
      </v-btn>
    </transition>

    <transition name="slide-fade" :duration="{ enter: 300, leave: 300 }">
      <v-card v-show="isVisible" class="ma-3" width="400px">
        <v-card-title class="text-right">
          <v-btn color="primary" fab x-small dark @click="toggle(false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-spacer/>
          Files
          <v-col sm="9" class="py-0">
            <v-select v-model="regionSelected" :items="regions" item-text="REGION" return-object label="Region" prepend-icon="mdi-earth" clearable/>
          </v-col>

        </v-card-title>

        <v-card-text id="fileList">
          <v-list subheader rounded>
            <v-list-item v-for="(file, index) in filteredFiles" :key="index" class="border">
              <v-list-item-avatar>
                <v-icon class="grey lighten-1" dark>mdi-file</v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-text="file.NOMBRE"></v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-row no-gutters>
                  <v-col>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on" @click="openFileMap(file)">
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Load on map</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FileList',

  data: () => ({
    isVisible: true,
    regionSelected: null
  }),

  computed: {
    ...mapGetters('file', [
      'files'
    ]),
    ...mapGetters('region', [
      'regions'
    ]),
    filteredFiles () {
      let files = this.files
      files = this.files.filter(x => x.TIPO_FICHERO.VISIBLE_MAPA === true)
      if (this.regionSelected) {
        files = files.filter(x => x.ID_REGION === this.regionSelected.ID_REGION)
      }

      /* if (this.fileTypeSelected) {
        files = files.filter(x => x.ID_TIPO_FICHERO === this.fileTypeSelected.ID_TIPO_FICHERO)
      } */

      return files
    }
  },

  methods: {
    toggle (isVisible) {
      this.isVisible = isVisible
    },
    openFileMap (file) {
      // this.$router.push({ path: 'map', query: { idFile: file.ID_FICHERO } })
      this.$emit('onViewFile', file.ID_FICHERO)
    }
  }
}
</script>

<style scoped>
  #fileList {
    height: auto;
    max-height: calc(100vh - 350px);
    overflow-y: auto;
  }

  /* Transitions */
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(-350px);
    opacity: 0;
  }
  .border{
    border: 1px solid #CCC;
  }
</style>
